<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section container">
            <div class="icon-title-container">
                <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
                <span class="title font-poppins">{{ category || productCategories.All }}</span>
            </div>
            <p class="subtitle">Discover amazing toy blocks and sets for endless creativity</p>
        </div>
    </div>

    <div class="bottom-section-container">
        <div class="bottom-section container">
            <div class="filter-section" *ngIf="isOpenFilter">
                <div class="filter-section-heading">
                    <span class="filters font-poppins">Filters</span>
                    <span class="clear" (click)="clearFilterItems()">Clear All</span>
                    <mat-icon class="filter-close" (click)="toggleFilterButton()">close</mat-icon>
                </div>

                @if (category !== productCategories.BuyBlocks) {
                <div class="separator"></div>
                }

                <!-- filter section -->
                <div
                    class="sub-category-section"
                    *ngIf="availableSubCategories.length && !searchQuery && category !== productCategories.BuyBlocks"
                >
                    <div class="sub-category-heading">
                        <span>Sub Categories</span>
                    </div>

                    <!-- subCategory section -->
                    <div class="subCategories">
                        @for (subCategory of availableSubCategories; track subCategory; let i = $index) {
                        <div
                            class="subCategory font-inter"
                            [ngClass]="{ isActive: isActiveSubCategory(subCategory!) }"
                            (click)="selectSubCategory(subCategory!)"
                        >
                            <span>{{ subCategory }}</span>
                        </div>
                        }
                    </div>
                </div>

                @if (category !== productCategories.BuyBlocks) {
                <div class="separator"></div>
                }

                <!-- Price Range -->
                <div class="price-range-section">
                    <div class="price-section-heading">
                        <p class="price-section-title">Price Range</p>
                    </div>

                    <div class="price-section">
                        <span class="currency font-inter">Min Price(₹)</span>
                        <input type="number" placeholder="Min" [(ngModel)]="minPrice" (blur)="onBlur($event, true)" />
                        <span class="currency font-inter">Max Price(₹)</span>
                        <input type="number" placeholder="Max" [(ngModel)]="maxPrice" (blur)="onBlur($event, false)" />
                    </div>

                    <button class="apply" (click)="applyPriceFilter()">Apply Filter</button>
                </div>
            </div>

            <div class="product-section">
                <div class="product-section-top">
                    <div class="filter-btn-products-found-container">
                        <button mat-flat-button class="filter-btn" (click)="toggleFilterButton()">
                            <mat-icon class="filter-icon">filter_alt</mat-icon> Filter
                        </button>
                    </div>

                    <div class="price-sort">
                        <mat-form-field
                            class="box-outline dense-3 input-border-radius"
                            appearance="outline"
                            subscriptSizing="dynamic"
                        >
                            <mat-select
                                class="sort-select-trigger"
                                panelClass="sort-select-panel"
                                [(value)]="selectedSort"
                                (selectionChange)="onPriceSortingChange($event)"
                                placeholder="Sort by Popularity"
                            >
                                <mat-select-trigger>
                                    {{ sortLabel }}
                                </mat-select-trigger>
                                <mat-option value="hightolow">{{
                                    "productList.label.priceHighToLow" | translate
                                }}</mat-option>
                                <mat-option value="lowtohigh">{{
                                    "productList.label.priceLowToHigh" | translate
                                }}</mat-option>
                                <mat-option value="highestRated">Highest Rated</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="product-section-bottom-container">
                    <mat-spinner *ngIf="isLoading" class="loading-spinner" [diameter]="50"></mat-spinner>
                    <div
                        class="product-section-bottom"
                        *ngIf="productList.length > 0; else noProducts"
                        [ngClass]="{ showList: isListView }"
                    >
                        @for (product of productList; let i = $index; track i) {
                        <app-product-card
                            [product]="product"
                            [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
                        ></app-product-card>
                        }
                    </div>
                </div>

                <div *ngIf="this.totalProducts - this.productList.length > 0" class="btn-content">
                    <button mat-flat-button class="btn-primary-gradient" (click)="onViewMoreClick()">
                        View More Items
                    </button>
                </div>

                <div class="right-navbar" *ngIf="isNavbarOpen">
                    <app-right-navbar (closeEvent)="onCloseNavbar()"></app-right-navbar>
                </div>

                <ng-template #noProducts>
                    <div class="no-products-wrapper" *ngIf="!isLoading">
                        <div class="no-products-card">
                            <!-- icon -->
                            <div class="icon-wrapper">
                                <mat-icon [svgIcon]="'noproduct'" class="icon1"></mat-icon>
                                <mat-icon [svgIcon]="'search'" class="icon2"></mat-icon>
                            </div>

                            <div class="content">
                                <!-- title -->
                                <span>No Product Found</span>
                                <!-- description -->
                                <p>
                                    Oops! This product doesn’t exist.
                                    <br />
                                    Start exploring toys for your little one!.
                                </p>
                                <br />
                                <button (click)="goBack()">← Back to Products</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
